import { render, staticRenderFns } from "./DealLinkPreview.vue?vue&type=template&id=3b2979dc&scoped=true&"
import script from "./DealLinkPreview.vue?vue&type=script&lang=js&"
export * from "./DealLinkPreview.vue?vue&type=script&lang=js&"
import style0 from "./DealLinkPreview.vue?vue&type=style&index=0&id=3b2979dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2979dc",
  null
  
)

export default component.exports